import React, { useState, useEffect, useContext } from "react";
import api from "../api";
import { AuthContext } from "../context/AuthContext";
import { FaUserEdit, FaTrash, FaPlus, FaSave, FaTimes } from "react-icons/fa";

const AdminUsers = () => {
  const { isAuthenticated, isAdmin } = useContext(AuthContext);
  const [usuarios, setUsuarios] = useState([]);
  const [editUsuario, setEditUsuario] = useState(null);

  const [emails, setEmails] = useState([]);
  const [novoEmail, setNovoEmail] = useState("");

  useEffect(() => {
    if (isAuthenticated && isAdmin) {
      carregarUsuarios();
      carregarEmails();
    }
  }, [isAuthenticated, isAdmin]);

  const carregarUsuarios = async () => {
    try {
      const response = await api.get("/usuarios");
      setUsuarios(response.data);
    } catch (error) {
      console.error("Erro ao buscar usuários:", error);
    }
  };

  const carregarEmails = async () => {
    try {
      const response = await api.get("/contatos-notificacao");
      setEmails(response.data);
    } catch (error) {
      console.error("Erro ao buscar e-mails de notificação:", error);
    }
  };

  const handleSalvarEdicao = async () => {
    if (!editUsuario) return;
    try {
      await api.put(`/usuarios/${editUsuario.id}`, { is_admin: editUsuario.is_admin });
      setEditUsuario(null);
      carregarUsuarios();
    } catch (error) {
      console.error("Erro ao editar usuário:", error);
    }
  };

  const handleExcluirUsuario = async (id) => {
    if (!window.confirm("Tem certeza que deseja excluir este usuário?")) return;
    try {
      await api.delete(`/usuarios/${id}`);
      carregarUsuarios();
    } catch (error) {
      console.error("Erro ao excluir usuário:", error);
    }
  };

  const handleAdicionarEmail = async (e) => {
    e.preventDefault();
    try {
      await api.post("/contatos-notificacao", [{ email: novoEmail, receber_email: true }]);
      setNovoEmail("");
      carregarEmails();
    } catch (error) {
      console.error("Erro ao adicionar e-mail de notificação:", error);
    }
  };

  const handleExcluirEmail = async (id) => {
    if (!window.confirm("Excluir este e-mail de notificação?")) return;
    try {
      await api.delete(`/contatos-notificacao/${id}`);
      carregarEmails();
    } catch (error) {
      console.error("Erro ao excluir e-mail:", error);
    }
  };

  if (!isAuthenticated || !isAdmin) {
    return <p className="text-red-500">Acesso negado. Apenas administradores podem gerenciar usuários.</p>;
  }

  return (
    <div className="max-w-3xl mx-auto mt-10 bg-white p-8 rounded-lg shadow-lg">
      <h2 className="text-2xl font-semibold text-gray-700 mb-6">Painel de Administração</h2>

      {/* 🔹 Gerenciamento de Usuários */}
      <h3 className="text-lg font-semibold mb-2">Usuários</h3>
      <p className="text-sm text-gray-500 mb-4">Usuários são criados automaticamente ao fazer login com Google.</p>

      <ul className="mb-10">
        {usuarios.map((usuario) => (
          <li key={usuario.id} className="flex justify-between items-center border-b py-2">
            {editUsuario?.id === usuario.id ? (
              <div className="flex items-center w-full space-x-2">
                <span className="w-full text-gray-700">{usuario.email || usuario.username}</span>
                <label className="inline-flex items-center">
                  <input
                    type="checkbox"
                    checked={editUsuario.is_admin}
                    onChange={(e) => setEditUsuario({ ...editUsuario, is_admin: e.target.checked })}
                  /> <span className="ml-1">Admin</span>
                </label>
                <button onClick={handleSalvarEdicao} className="text-green-600"><FaSave /></button>
                <button onClick={() => setEditUsuario(null)} className="text-red-600"><FaTimes /></button>
              </div>
            ) : (
              <>
                <div>
                  <span className="font-medium">{usuario.username}</span>
                  {usuario.email && <span className="text-sm text-gray-500 ml-2">({usuario.email})</span>}
                  {usuario.is_admin && <span className="ml-2 text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded">Admin</span>}
                </div>
                <div className="flex space-x-2">
                  <button onClick={() => setEditUsuario(usuario)} className="text-yellow-500"><FaUserEdit /></button>
                  <button onClick={() => handleExcluirUsuario(usuario.id)} className="text-red-500"><FaTrash /></button>
                </div>
              </>
            )}
          </li>
        ))}
      </ul>

      {/* 🔹 Gerenciamento de E-mails de Notificação */}
      <div className="mt-10">
        <h3 className="text-lg font-semibold mb-2">E-mails para Notificações de Estoque</h3>
        <form onSubmit={handleAdicionarEmail} className="flex space-x-2 mb-4">
          <input type="email" placeholder="Novo e-mail" className="px-4 py-2 border rounded-lg w-full" value={novoEmail} onChange={(e) => setNovoEmail(e.target.value)} required />
          <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded-lg flex items-center"><FaPlus className="mr-2" /> Adicionar</button>
        </form>
        <ul>
          {emails.map((item) => (
            <li key={item.id} className="flex justify-between items-center border-b py-2">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between w-full">
                <span className="mb-2 sm:mb-0">{item.email}</span>

                <div className="flex items-center space-x-4">
                  <label className="inline-flex items-center">
                    <input
                      type="checkbox"
                      className="mr-2"
                      checked={item.receber_email}
                      onChange={async (e) => {
                        try {
                          await api.put(`/contatos-notificacao/${item.id}`, { receber_email: e.target.checked });
                          carregarEmails();
                        } catch (error) {
                          console.error("Erro ao atualizar preferência de e-mail:", error);
                        }
                      }}
                    />
                    Receber e-mail
                  </label>

                  <button onClick={() => handleExcluirEmail(item.id)} className="text-red-500">
                    <FaTrash />
                  </button>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AdminUsers;
